export const range = (x: number): number[] => Array.from(Array(x).keys());
